import { types, flow } from "mobx-state-tree";
import { toJS } from "mobx";
import { formatRFC3339 } from "date-fns";
import MessageService from '../../service/MessageService';
import StatusCode from "../../utils/errorsCode";
const query = types.model({
    _id: types.union(types.string),
    name: types.optional(types.string, "")
})

const owner = types.model({
    _id: types.string,
    username: types.string
})

const last_edit_by = types.model({
    _id: types.string,
    username: types.string
})

const message = types.model({
    id: types.optional(types.number, 0),
    title: types.optional(types.string, ""),
    tracking_id: types.optional(types.string, ""),
    owner: types.maybeNull(owner),
    content: types.optional(types.string, ""),
    last_edit_by: types.maybeNull(last_edit_by),
    action: types.optional(types.number, 1),
    link: types.optional(types.string, ""),
    created_at: types.optional(types.string, formatRFC3339(new Date())),
    updated_at: types.optional(types.string, formatRFC3339(new Date())),
    device: types.optional(types.array(types.string), []),
})

export const Messages = types.model({
    messages: types.optional(types.array(message), []),
    state: types.optional(types.enumeration(["running", "done", "init"]), "init"),
    messagesLoading: types.optional(types.boolean, false),
    searchQuery: types.optional(types.array(query), [])
})
    .actions(self => ({
        getMessages: flow(function* (params) {
            self.messagesLoading = true
            try {
                const resp = yield MessageService.get(params);
                const { status, data } = resp;
                if (status) {
                    self.setMessages(data);
                } else {
                    throw new Error("Messages is not found!");
                }
            } catch ({data}) {
                if (!data.status) {
                    alert(StatusCode[data.error])
                }
            }
            self.messagesLoading = false
        }),
        create: flow(function* (data) {
            try {
                const resp = yield MessageService.create(data);
                const { status } = resp;
                if (status) {
                    self.getMessages();
                } else {
                    throw new Error("Cannot add new message!")
                }
            } catch ({data}) {
                if (!data.status) {
                    alert(StatusCode[data.error])
                }
            }
        }),
        update: flow(function* (data, id) {
            try {
                const resp = yield MessageService.update(data, id);
                if (resp.status) {
                    self.getMessages();
                } else {
                    throw new Error("Cannot update message!")
                }
            } catch ({data}) {
                if (!data.status) {
                    alert(StatusCode[data.error])
                }
            }
        }),
        removeMessage: flow(function* (id) {
            try {
                const resp = yield MessageService.remove(id);
                if (resp.status) {
                    self.getMessages();
                }
            } catch ({data}) {
                if (!data.status) {
                    alert(StatusCode[data.error])
                }
            }
        }),
        addRequest: flow(function* (data) {
            try {
                yield MessageService.addNotiRequest(data);
            } catch ({data}) {
                if (!data.status) {
                    alert(StatusCode[data.error])
                }
            }
        }),
        getSearchQuery: flow(function* (params) {
            try {
                const res = yield MessageService.getSearchQuery(params);
                if (res.status) {
                    self.searchQuery = res.data
                }
            } catch ({data}) {
                if (!data.status) {
                    alert(StatusCode[data.error])
                }
            }
        }),
        setMessages(data) {
            self.messages = data;
        }
    }))
    .views(self => ({
        get getList() {
            return toJS(self.messages);
        },
        get getState() {
            return toJS(self.state)
        },
        get getMessagesLoading() {
            return toJS(self.messagesLoading)
        },
        get listSearchQuery() {
            return toJS(self.searchQuery)
        }
    }))